<template>
<div>
  <div class="page" v-if="$store.getters['auth/isAllowed']('can_view_admin_panel')">
    <div class="col-10 d-flex align-center">
      <h1 class="font-lg">Админ-панель</h1>
    </div>
    <div v-if="loading.admin" class="h-100 d-flex justify-center align-center">
      <v-progress-circular :size="50" color="primary" indeterminate/>
    </div>
    <BreadCrumbs :items="breadcrumbs" />
    <ProfileTopPanel
      v-if="admin"
      userTypeName="Администратор"
      :name="admin.last_name + ' ' + admin.first_name"
      :city="admin.city"
      :phone="admin.phone"
      :email="admin.email"
      permssionEdit="edit_admin"
      permssionDelete="_delete_admin"
      whoDelete="администратора"
      @delete="onDelete()" @edit="onEdit()"
    />
    <div class="row">
      <div
        class="col-6 col-md-6"
        v-for="(item,idx) of adminPanelItems"
        :key="idx"
      >
        <ProfileCard
          v-if="item.isVisible"
          :title="item.title"
          :showLinkAnyway="true"
          @linkClicked="goToPage(item.url)"
        />
      </div>
    </div>
    <v-main class="bg-main h-100">
      <router-view />
    </v-main>
  </div>

</div>
</template>

<script>
import ProfileTopPanel from '@/components/common/ProfileTopPanel.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AdminPanel',
  components: {
    ProfileTopPanel
  },
  computed: {
    ...mapGetters({
      admin: 'users/admins/admin',
      loading: 'users/admins/loading',
      user: 'auth/user',
    }),
    breadcrumbs() {
      if (!this.manager) return [];
      return this.isProfile ? [
        { title: 'Личный кабинет', url: '/' },
      ] : [
        { title: 'Менеджеры', url: '/managers/' },
        { title: `${this.manager.last_name} ${this.manager.first_name}`, url: `/managers/${this.manager.id}` },
      ];
    },
    adminPanelItems() {
      return [
        {
          name: '',
          title: 'Управление баннерами',
          url: 'banners',
          isVisible: true,
        },
        {
          name: '',
          title: 'Управление новостями сервиса',
          url: 'news',
          isVisible: true,
        },
        {
          name: '',
          title: 'Управление услугами',
          url: 'admin-services',
          isVisible: true,
        },
        {
          name: '',
          title: 'Просмотр покупок и корзин пользователя',
          url: 'viewBaskets',
          isVisible: true,
        },
        {
          name: '',
          title: 'Управление обучающими материалами',
          url: 'educationMaterials',
          isVisible: true,
        },
        {
          name: '',
          title: 'Управление ролями',
          url: '',
          isVisible: false,
        },
        {
          name: '',
          title: 'Управление партнёрской программой',
          url: '',
          isVisible: false,
        },
      ];
    }

  },
  methods: {
    ...mapActions({
      loadAdmin: 'users/admins/loadAdmin',
    }),
    onEdit() {
      this.setEditedManager({ ...this.manager });
      this.setDialogEditShow(true);
    },
    onDelete() {
    },
    reload() {
      this.loadAdmin(this.user.id);
    },
    goToPage(path) {
      this.$router.push({
        ...this.$route.query,
        name: path,
      });
    }
  },
  mounted() {
    this.loadAdmin(this.user.id);
  },
};
</script>

<style scoped lang="scss">

</style>
